import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, EffectCoverflow, EffectFlip } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/thumbs';
import 'swiper/css/effect-cards';
import 'swiper/css/effect-flip';

// Initialize Swiper modules
Swiper.use([Navigation, Pagination, Grid, Autoplay, Thumbs, EffectCards, EffectCoverflow, EffectFlip]);

// Export for global use if needed
window.Swiper = Swiper

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// Lazyload
import lazySizes from 'lazysizes';

// fslightbox
import FsLightbox from "fslightbox";

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// PURECOUNTER
import PureCounter from "@srexi/purecounterjs";

const setupApp = ()=>
{
    lazySizes.init();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    const pure = new PureCounter({
        formater: "fa-Fa",
    });

    let productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    let productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });

};

["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})
